import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4ddf5e02&scoped=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"
import style0 from "./main.vue?vue&type=style&index=0&lang=less"
import style1 from "./main.vue?vue&type=style&index=1&id=4ddf5e02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf5e02",
  null
  
)

export default component.exports